import { render, staticRenderFns } from "./Datadisplay.vue?vue&type=template&id=45e437df&scoped=true"
import script from "./Datadisplay.vue?vue&type=script&lang=js"
export * from "./Datadisplay.vue?vue&type=script&lang=js"
import style0 from "./Datadisplay.vue?vue&type=style&index=0&id=45e437df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../TweeAT.HvA.CourseCatalog/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e437df",
  null
  
)

export default component.exports